const source = 'kec';
const Version = '2016-03-04';
const Service = 'kec';
const KecPath = '/kecapi/';
const noLoginKecApi = '/noLoginKecApi/'
const keadService = 'kead';
export const RegionList = {
    path: KecPath,
    params: {
        Action: 'RegionList',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const CalcEipPrice = {
    path: KecPath,
    params: {
        Action: 'CalculateEIPPrice',
        Version,
        Service,
        source
    },
    method: 'post'
};


export const RegionInfos = {
    path: KecPath,
    params: {
        Action: 'RegionInfos',
        Service,
        Version,
        source
    },
    method: 'get'
};


export const QueryProductGroups = {
    path: KecPath,
    params: {
        Action: 'QueryProductGroups',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const Getlines = {
    path: KecPath,
    params: {
        Action: 'Getlines',
        Service: 'eip',
        Version,
        source
    },
    method: 'get'
};

export const DescribeBandWidthShares = {
    path: KecPath,
    params: {
        Action: 'DescribeBandWidthShares',
        Service: 'bws',
        Version,
        source
    },
    method: 'get'
};

export const OSImageList = {
    path: KecPath,
    params: {
        Action: 'ImageConfig',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const ImageList = {
    path: KecPath,
    params: {
        Action: 'DescribeImages',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const DedicatedList = {
    path: KecPath,
    params: {
        Action: 'DescribeDedicatedHosts',
        Service,
        Version,
        source
    },
    method: 'post'
};

export const projList = {
    path: KecPath,
    params: {
        Action: 'GetAccountProjectList',
        Service: 'iam',
        Version: '2015-11-01',
        source
    },
    method: 'get'
};

export const getDedicatedCluster = {
    path: KecPath,
    params: {
        Action: 'DescribeDedicatedCluster',
        Service,
        Version,
        source
    },
    method: 'post'
};

export const snapList = {
    path: KecPath,
    params: {
        Action: 'DescribeLocalVolumeSnapshots',
        Service,
        Version,
        source
    },
    method: 'post'
};

export const snapLessNum = {
    path: KecPath,
    params: {
        Action: 'CreateSnapshotInstNum',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const getEbsSnap = {
    path: KecPath,
    params: {
        Action: 'DescribeSnapshots',
        Version,
        Service,
        source
    },
    method: 'post'
}

//查询（描述)本地盘快照信息
export const describeLocalVolumeSnapshots = {
    path: KecPath,
    params: {
        Action: 'DescribeLocalVolumeSnapshots',
        Version,
        Service,
        source
    },
    method: 'post'
}
export const CalculateKeadProduct = {
    path: KecPath,
    params: {
        Action: 'CalculateKeadProduct',
        Version,
        Service:keadService
    },
    method: 'post'
}
//--以下为未登录service--
export const noLoginQueryProductGroups = {
    path: noLoginKecApi,
    params: {
        Action: 'QueryProductGroups',
        Service,
        Version,
        source
    },
    method: 'get'
};

export const noLoginGetlines = {
    path: noLoginKecApi,
    params: {
        Action: 'Getlines',
        Service: 'eip',
        Version,
        source
    },
    method: 'get'
};
// --以上为未登录service--